import { FC } from 'react';
import SkeletonLoader from 'src/common/components/SkeletonLoader';
import SkeletonBlock from 'src/common/components/SkeletonLoader/SkeletonBlock';
import styles from './TripCartSkeleton.module.scss';

export type Props = {};

const TripCartSkeleton: FC<Props> = () => (
  <div className={styles.root}>
    <div className={styles.desktop}>
      <SkeletonLoader>
        <SkeletonBlock size={10} />
        <SkeletonBlock size={4} />
        <SkeletonBlock size={4} />
      </SkeletonLoader>
      <SkeletonLoader>
        <SkeletonBlock size={4} />
        <SkeletonBlock size={10} />
        <SkeletonBlock size={4} />
        <SkeletonBlock size={4} />
      </SkeletonLoader>
      <SkeletonLoader>
        <SkeletonBlock size={4} />
        <SkeletonBlock size={4} />
        <SkeletonBlock size={10} />
        <SkeletonBlock size={4} />
      </SkeletonLoader>
      <SkeletonLoader>
        <SkeletonBlock size={4} />
        <SkeletonBlock size={10} />
      </SkeletonLoader>
    </div>
  </div>
);

export default TripCartSkeleton;
